import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { appConfig } from './app.config';

const browserConfig: ApplicationConfig = {
  providers: [provideClientHydration()],
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
